import { Component, OnInit, Input, Inject, ViewChild, ElementRef, HostListener } from '@angular/core';
import { ISiteHeaderSettings } from 'src/app/shared/interface/site-settings';
import { NavigationService, INavigationItem, IHeaderItem, ILanguageItem } from 'src/app/service/navigation.service';
import { PictureData } from 'src/app/dynamic-module/lib/helper/picture-data';
import { IPictureData } from 'src/app/shared/components/picture/picture.component';
import { DrawerService, DrawerState } from 'src/app/dynamic-module/lib/drawer/service/drawer.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from '@angular/router';


enum ItemState {
  opened = 'opened',
  closed = 'closed'
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
  animations: [
    trigger('items', [
      state('opened', style({
        opacity: '1',
        height: '*'
      })),
      state('closed', style({
        opacity: '0',
        height: '0',
        display: 'none'
      })),
      transition('opened <=> closed', [animate('.2s')])
    ]),
    trigger('arrow', [
      state('opened', style({
        transform: 'rotate(180deg)'
      })),
      state('closed', style({
        transform: 'rotate(0deg)'
      })),
      transition('* => *', [animate('.2s')])
    ])
  ]
})
export class HeaderComponent implements OnInit {
  @Input() navigation: INavigationItem[];
  @Input() header: IHeaderItem;
  @Input() settings: ISiteHeaderSettings;
  @ViewChild('topNavLinksEl', { static: false }) topNavLinksElRef: ElementRef<HTMLElement>;
  @ViewChild('headerEl', { static: false }) headerElRef: ElementRef<HTMLElement>;
  @ViewChild('topNav', { static: false }) topNavEl: ElementRef<HTMLElement>;

  logo: IPictureData;
  burger: any;
  state: DrawerState;
  langState = ItemState.closed;
  navState = ItemState.closed;
  languages: { languages: ILanguageItem[] };
  inactiveLangs: ILanguageItem[] = [];

  @HostListener('window:resize', ['$event']) onResize(event?) {
    this.setHeaderHeight();
  }

  constructor(
    public drawerService: DrawerService,
    public navigationService: NavigationService,
    @Inject('Window') window: Window,
    private router: Router
  ) {
    router.events.subscribe((val) => {
      this.closeNav();
    });
  }

  ngOnInit() {
    this.navigationService.getHeaderNavigation().subscribe((res: IHeaderItem) => {
      this.header = res;
      this.setCustomStyles();
    });
    this.navigationService.getLanguage().subscribe((res: { languages: ILanguageItem[] }) => {
      this.languages = res;
      const inactiveLangs = this.languages && this.languages.languages && this.languages.languages.filter(lang => lang && window.location.hostname !== lang.url)
      this.inactiveLangs = inactiveLangs && inactiveLangs.length ? inactiveLangs : [];
    });
    this.logo = PictureData.fromUrlWithRect('wwwroot/assets/img/logo.png', { width: 92, height: 92 });
    this.burger = '/media/savm0ni5/burger.png';
  }

  ngAfterViewInit(): void {
    this.setHeaderHeight();
  }

  langPicker(url: string): void {
    window.location.href = url;
  }

  toggleLang() {
    this.langState === ItemState.closed ? this.langState = ItemState.opened : this.langState = ItemState.closed;
  }

  toggleMobileMenu() {
    this.navState === ItemState.closed ? this.navState = ItemState.opened : this.navState = ItemState.closed;
  }

  closeNav() {
    this.navState = ItemState.closed;
  }

  setHeaderHeight() {
    let height = this.topNavLinksElRef.nativeElement.clientHeight;

    this.headerElRef.nativeElement.style.marginTop = height + 'px';
  }

  setCustomStyles() {
    if (this.topNavEl) { 
      if (this.header.topBackgroundColor) {
        this.topNavEl.nativeElement.style.setProperty('--header-top-bar-background-color', this.header.topBackgroundColor);
      }
      if (this.header.topTextColor) {
        this.topNavEl.nativeElement.style.setProperty('--header-top-bar-text-color', this.header.topTextColor);
      }
    }
    if (this.headerElRef) {
      if (this.header.bottomBackgroundColor) {
        this.headerElRef.nativeElement.style.setProperty('--header-navigation-bar-background-color', this.header.bottomBackgroundColor);
      }
      if (this.header.bottomTextColor) {
        this.headerElRef.nativeElement.style.setProperty('--header-navigation-bar-text-color', this.header.bottomTextColor);
      }
    }
  }
}
